
import Vue from 'vue'

import './registerServiceWorker'

var pjson = require('../package.json')
console.info('Charles version ' + pjson.version)

/**
 * Vue Modules
 */
import ElementUI from 'element-ui'
import locale from 'element-ui/lib/locale/lang/en'
import 'element-ui/lib/theme-chalk/index.css'
import 'vue-awesome/icons'
import VueShortkey from 'vue-shortkey'
import 'vue-awesome/icons'
import Icon from 'vue-awesome/components/Icon'
import VueResource from 'vue-resource'
import VueProgressBar from 'vue-progressbar'
import VueResourceProgressBarInterceptor from 'vue-resource-progressbar-interceptor'

import store from './vuex/store'
import router from './util/router'
import wsClient from './util/wsClient'
import webPush from './util/webPush'
import { SENTRY_DSN } from './config'
// sync(store, router)

// Custom Components
import Log from './components/lists/list-items/Log'
import TaskListItem from './components/lists/list-items/TaskListItem'
import LogList from './components/lists/LogList'
import ProjectList from './components/lists/ProjectList'
import TaskList from './components/lists/TaskList'
import TaskTimer from './components/misc/TaskTimer'
import AppBuildCRUD from './components/crud/AppBuildCRUD'
import ClientCRUD from './components/crud/ClientCRUD'
import ProjectCRUD from './components/crud/ProjectCRUD'
import TaskCRUD from './components/crud/TaskCRUD'
import UserCRUD from './components/crud/UserCRUD'
import LogCRUD from './components/crud/LogCRUD'
import ClientCode from './components/misc/ClientCode'
import WeekTotalTags from './components/misc/WeekTotalTags'
import ProjectHoursTags from './components/misc/ProjectHoursTags'
import ProjectAvatars from './components/misc/ProjectAvatars'
import UserSelector from './components/misc/UserSelector'
import ProjectFilters from './components/misc/ProjectFilters'
import ProjectListTable from './components/lists/ProjectListTable'
import ProgressBar from './components/misc/ProgressBar'

// Start error logging
import * as Sentry from '@sentry/browser'
if (process.env.NODE_ENV === 'production') {
  Sentry.init({
    dsn: SENTRY_DSN,
    integrations: [new Sentry.Integrations.Vue({Vue})],
    release: pjson.version,
    environment: process.env.NODE_ENV
  })
}

/**
 * Tell Vue to use our components
 */

Vue.use(ElementUI, { locale })

Vue.use(VueResource)
Vue.use(VueProgressBar)
Vue.use(VueResourceProgressBarInterceptor, {
  latencyThreshold: 100, // Number of ms before progressbar starts showing, 100 is default
  responseLatency: 1000 // Number of ms before progressbar starts reacting to response, 50 is default
  // Can be used to wait for more requests to kick in under single progress bar
})

Vue.component('icon', Icon)

Vue.use(VueShortkey)

// Custom global components (mainly CRUD dialogs)
Vue.component('log', Log)
Vue.component('log-list', LogList)
Vue.component('project-list', ProjectList)
Vue.component('task-list', TaskList)
Vue.component('task-list-item', TaskListItem)
Vue.component('task-timer', TaskTimer)
Vue.component('app-build-crud', AppBuildCRUD)
Vue.component('project-crud', ProjectCRUD)
Vue.component('client-crud', ClientCRUD)
Vue.component('task-crud', TaskCRUD)
Vue.component('user-crud', UserCRUD)
Vue.component('log-crud', LogCRUD)
// Vue.component('infinite-loading', InfiniteLoading)
Vue.component('client-code', ClientCode)
Vue.component('week-total-tags', WeekTotalTags)
Vue.component('project-hours-tags', ProjectHoursTags)
Vue.component('project-avatars', ProjectAvatars)
Vue.component('user-selector', UserSelector)
Vue.component('project-filters', ProjectFilters)
Vue.component('project-list-table', ProjectListTable)
Vue.component('progress-bar', ProgressBar)

/**
 * Start the App
 */
import App from './App'

Vue.config.productionTip = false
new Vue({
  el: '#app',
  store,
  router,
  components: { App },
  render: h => h(App),
  methods: {
    initWebSocketClient () {
      if (this.$store.state.accessToken && this.$store.state.users.currentUser && !wsClient.initialized) {
        wsClient.init()
      } else if (!this.$store.state.accessToken && wsClient.initialized) {
        wsClient.stop()
      }
    },

    // WEB PUSH SETUP
    initWebPushSubscription () {
      if (this.$store.state.accessToken && !webPush.initialized) {
        webPush.init()
      } else if (!this.$store.state.accessToken && webPush.initialized) {
        webPush.unsubscribe()
      }
    }
  },
  created () {
    this.initWebSocketClient()
    this.initWebPushSubscription()
  },

  watch: {
    '$store.state.accessToken' () {
      // Watch for Login (changes to the access token) and start/stop the pusher
      // client when the user has logged in/out
      this.initWebSocketClient()
      this.initWebPushSubscription()
    },
    '$store.state.users.currentUser' () {
      // Watch for Login (changes to the access token) and start/stop the pusher
      // client when the user has logged in/out
      this.initWebSocketClient()
      this.initWebPushSubscription()
    }
  }
})
